<template lang='pug'>
  r-form(
    no-buttons
    ref='form'
    v-bind='formProps'
    v-model='formData'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import { canRouteEnter } from '@/plugins/mod-can'
  import PchPurchaseOrderService from '@/services/api/purchase/PchPurchaseOrder'
  //
  export default {
    name: 'pch-purchase-order-detail',
    components: {
      RForm,
    },
    computed: {
      formProps() {
        return {
          title: 'Orden de compra #' + this.$route.params.id,
          fields: PchPurchaseOrderService.fields(),
          editable: false,
          switchEdit: false,
          readOnly: true,
        }
      },
    },
    data() {
      return {
        formData: {},
      }
    },
    methods: {

      /**
       * Gets the form data.
       *
       * @return     {<type>}  The form data.
       */
      getFormData() {
        return PchPurchaseOrderService
          .modeler()
          .find(this.$route.params.id)
      },

      /**
       * Sets the form data.
       *
       * @param      {<type>}  model   The model
       */
      setFormData(model) {
        this.formData = model.reset()
      },

      /**
       * Resets the object.
       */
      reset() {
        this
          .toWait(true)
          .then(this.getFormData)
          .then(this.setFormData)
          .then(this.toWait)
      },

      /**
       * Set form wait state.
       *
       * @param      {boolean}  [value=false]  The value
       * @return     {<type>}   { description_of_the_return_value }
       */
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle('Detalle de orden de compra')
    },
    mounted() {
      this.reset()
    },
    beforeRouteEnter: canRouteEnter('VIEW_DETAIL_PURCHASE_ORDER'),
  }
</script>
